module.exports = __webpack_public_path__ + "static/img/aa.b167ec7c.png";